import { gql } from '@apollo/client'

export const socialProfileRemoveByIdMutation = gql`
  mutation SocialProfileRemoveById($_id: String!) {
    socialProfileRemoveById(_id: $_id)
  }
`
